// ABOUTME: 5x5 bingo grid component for the player scorecard.
// ABOUTME: In automatic mode, nothing is clickable. In manual mode, any non-required square is clickable.
import Typography from '@mui/material/Typography'
import { BingoGridContainer, BingoGridCell } from '../theme'
import type { ScoreCardGameSquareDto } from '../api/generated'

interface BingoGridProps {
  squares: ScoreCardGameSquareDto[]
  onMark: (squareId: string) => void
  automatic: boolean
}

export function BingoGrid({ squares, onMark, automatic }: BingoGridProps) {
  return (
    <BingoGridContainer>
      {squares.map((sq) => {
        const isFree = sq.gameSquare?.free ?? false
        const isClickable = !automatic && !isFree && !sq.marked
        const classes = [
          sq.marked ? 'marked' : '',
          !isClickable ? 'disabled' : '',
        ].filter(Boolean).join(' ')
        return (
          <BingoGridCell
            key={sq.id}
            role="button"
            data-testid={`square-${sq.id}`}
            className={classes}
            style={{ gridColumn: sq.xCoordinate + 1, gridRow: sq.yCoordinate + 1 }}
            onClick={() => { if (isClickable) onMark(sq.id) }}
          >
            <Typography variant="body2">{sq.gameSquare?.title}</Typography>
          </BingoGridCell>
        )
      })}
    </BingoGridContainer>
  )
}
